import React from 'react'
import { componentGetCompareProps, MessageBusWrapper, BuildMessageBusEvents } from 'common-tools/index'
import AceEditor from 'react-ace'
import _ from 'common-tools/LodashHelper'
import 'ace-builds/src-noconflict/mode-ejs'
import 'ace-builds/src-noconflict/theme-github'
import { beautify } from 'ace-builds/src-noconflict/ext-beautify'
import { compose } from 'common-data/datahelpers'

export const EJSEditorEvents = BuildMessageBusEvents('Controls.EJSEditor', ['Format'])

class EJSEditorPlain extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      containerHeight: '0px',
      containerWidth: '0px',
      firstRenderDone: false,
      code: '',
      annotations: []
    }
  }

  wrapperDiv = null
  editor = null

  componentDidMount () {
    this.updateDimensions()
  }

  onNewMessage (msg) {
    switch (msg.Type) {
      case EJSEditorEvents.Format:
        if (this.editor) {
          beautify(this.editor.editor.session)
        }
        break
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const splitSize = componentGetCompareProps('splitSize', this.props, prevProps, 0)

    if (!this.props.noResize && splitSize.HasChanged) {
      this.updateDimensions()
    }

    if (this.editor) {
      const { annotations } = this.state
      let workerAnnotations = this.editor.editor.getSession().getAnnotations() || []
      const allnotations = _.concat([], annotations, _.reject(workerAnnotations, (a) => { return a.acorn === true }))
      // console.log('Setting Annotations ==============================================')
      // console.log(allnotations)
      this.editor.editor.getSession().setAnnotations(allnotations)
    }
  }

  updateDimensions () {
    if (this.wrapperDiv) {
      const rect = this.wrapperDiv.getBoundingClientRect()
      this.setState({
        containerHeight: `${rect.height}px`,
        containerWidth: `${rect.width}px`
      })
    }
  }

  onChange = (newCode, event) => {
    const { onChange } = this.props

    this.setState({
      code: newCode
    }, () => {
      if (_.isFunction(onChange)) {
        onChange(newCode, event)
      }
    })
  }

  render () {
    const { containerHeight, containerWidth } = this.state
    const { className, noResize, ...rest } = this.props
    const allRestProps = _.omit(rest, ['onChange', 'annotations'])

    if (noResize) {
      return <AceEditor
        {...allRestProps}
        // onValidate={this.onValidate}
        ref={(r) => { this.editor = r }}
        onChange={this.onChange}
        height='100%'
        width='100%'
        theme='github'
        mode='ejs'
      />
    } else {
      return <div className={className} ref={(c) => { this.wrapperDiv = c }}>
        <AceEditor
          {...allRestProps}
          // onValidate={this.onValidate}
          ref={(r) => { this.editor = r }}
          onChange={this.onChange}
          height={containerHeight}
          width={containerWidth}
          theme='github'
          mode='ejs'
        />
      </div>
    }
  }
}

export const EJSEditor = compose(
  MessageBusWrapper({
    listenForAllMessages: true
  })
)(EJSEditorPlain)
